export const prepareStatementsForDisplay = (statements, t, hideCompletedStatements) => {
  const monthNames = t
    ? [
        t.read('month.January'),
        t.read('month.February'),
        t.read('month.March'),
        t.read('month.April'),
        t.read('month.May'),
        t.read('month.June'),
        t.read('month.July'),
        t.read('month.August'),
        t.read('month.September'),
        t.read('month.October'),
        t.read('month.November'),
        t.read('month.December'),
      ]
    : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return statements
    .filter(statement => !hideCompletedStatements || statement.all_transactions_matched !== true)
    .map((statement) => {
    return {
      ...statement,
      total_with_tax: `${statement.total_with_tax} $`,
      period: monthNames[statement.period - 1] || statement.period,
      account_mask: `**** **** **** ${statement.account_mask}`,
    };
  });
};

export const calculateAmountTotal = (transactions) => {
  const total = transactions.reduce((sum, transaction) => {
    const amount = parseFloat(transaction.amount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  const formatted = total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return formatted;
};
